export class ProjectPermission {
  constructor(public value: string) {}
}

export class CameraPermission {
  constructor(public value: string) {}
}

export const PROJECT_PERMISSIONS = Object.freeze({
  GATE_REPORT: {
    VIEW_EVENTS: new ProjectPermission("gate_report_view"),
    EXPORT_REPORTS: new ProjectPermission("gate_report_export"),
  },
  BIM_VIEW: {
    VIEW: new ProjectPermission("bim_view_view"),
    TOOLS: new ProjectPermission("bim_view_tools"),
    UPLOAD: new ProjectPermission("bim_view_upload"),
    SETTINGS: new ProjectPermission("bim_view_settings"),
  },
  DRONE_VIEW: {
    VIEW: new ProjectPermission("drone_view_view"),
    UPLOAD: new ProjectPermission("drone_view_upload"),
    TOOLS: new ProjectPermission("drone_view_tools"),
    COMPARE: new ProjectPermission("drone_view_compare"),
    SHARE_LINK: new ProjectPermission("drone_view_share_link"),
    SETTINGS: new ProjectPermission("drone_view_settings"),
  },
  VIEW_360: {
    VIEW: new ProjectPermission("360_view_view"),
    UPLOAD: new ProjectPermission("360_view_upload"),
    TOOLS: new ProjectPermission("360_view_tools"),
    COMPARE: new ProjectPermission("360_view_compare"),
    SHARE_LINK: new ProjectPermission("360_view_share_link"),
    SETTINGS: new ProjectPermission("360_view_settings"),
  },
  TIMELINE: {
    VIEW: new ProjectPermission("timeline_view"),
    USE_SMART_MILESTONES: new ProjectPermission(
      "timeline_use_smart_milestones"
    ),
    CONSTRUCTION_REPORTS: new ProjectPermission(
      "timeline_construction_reports"
    ),
  },
  MEDIA_HUB: {
    VIEW: new ProjectPermission("media_hub_view"),
    MAKE_PRIVATE: new ProjectPermission("media_hub_make_private"),
    EDIT_ACCESS: new ProjectPermission("media_hub_edit_access"),
    DELETE: new ProjectPermission("media_hub_delete"),
    UPLOAD: new ProjectPermission("media_hub_upload"),
  },
  WEATHER: {
    VIEW_CURRENT: new ProjectPermission("weather_view_current"),
    VIEW_PREDICTED: new ProjectPermission("weather_view_predicted"),
    VIEW_HISTORIC: new ProjectPermission("weather_view_historic"),
  },
  VIDEO_WALL: {
    VIEW: new ProjectPermission("video_wall_view"),
    CONFIGURE: new ProjectPermission("video_wall_configure"),
  },
  SITE_PLANNER: {
    VIEW: new ProjectPermission("site_planner_view"),
    EDIT: new ProjectPermission("site_planner_edit"),
  },
  SETTINGS: {
    VIEW: new ProjectPermission("settings_view"),
    EDIT: new ProjectPermission("settings_edit"),
    DELETE: new ProjectPermission("settings_delete"),
    ADD_USER: new ProjectPermission("settings_add_user"),
    EDIT_ROLES: new ProjectPermission("settings_edit_roles"),
    REMOVE_USER: new ProjectPermission("settings_remove_user"),
    RESTRICT_CAMERA_ACCESS: new ProjectPermission(
      "settings_restrict_camera_access"
    ),
  },
  AUTOMATIONS: {
    CREATE_PROGRESS_PHOTOS: new ProjectPermission(
      "automations_create_progress_photos"
    ),
    EDIT_PROGRESS_PHOTOS: new ProjectPermission(
      "automations_edit_progress_photos"
    ),
    PAUSE_PROGRESS_PHOTOS: new ProjectPermission(
      "automations_pause_progress_photos"
    ),
    DELETE_PROGRESS_PHOTOS: new ProjectPermission(
      "automations_delete_progress_photos"
    ),
  },
  COMMENTS: {
    VIEW: new ProjectPermission("comments_view"),
    CREATE: new ProjectPermission("comments_create"),
    EDIT: new ProjectPermission("comments_edit"),
    DELETE: new ProjectPermission("comments_delete"),
  },
})

export const CAMERA_PERMISSIONS = Object.freeze({
  LIVE_VIEW: {
    VIEW: new CameraPermission("live_view_view"),
  },
  RECORDINGS: {
    VIEW: new CameraPermission("recordings_view"),
    EXPORT_CLIP: new CameraPermission("recordings_export_clip"),
  },
  EDIT_TOOL: {
    EDIT_IMAGES: new CameraPermission("edit_tool_edit_images"),
    DOWNLOAD_IMAGES: new CameraPermission("edit_tool_download_images"),
    SAVE_IMAGES: new CameraPermission("edit_tool_save_images"),
    SEND_IMAGES: new CameraPermission("edit_tool_send_images"),
  },
  COMPARE: {
    VIEW: new CameraPermission("compare_view"),
    EXPORT_GIF: new CameraPermission("compare_export_gif"),
  },
  PTZ: {
    LIVE_VIEW: new CameraPermission("ptz_live_view"),
    MOVE: new CameraPermission("ptz_move"),
    RESET_POSITION: new CameraPermission("ptz_reset_position"),
    SET_HOME_POSITION: new CameraPermission("ptz_set_home_position"),
    ADD_PRESET: new CameraPermission("ptz_add_preset"),
    VIEW_PRESETS: new CameraPermission("ptz_view_presets"),
    DELETE_PRESETS: new CameraPermission("ptz_delete_presets"),
    EDIT_PRESET: new CameraPermission("ptz_edit_preset"),
  },
  TIME_LAPSE: {
    CREATE: new CameraPermission("time_lapse_create"),
    VIEW: new CameraPermission("time_lapse_view"),
  },
})
